import React from "react";
import { useHistory } from "react-router-dom";
import VideosTabs from "./VideosTabs";
import ListContainer from "./ListContainer";

const Mindfulness = ({ activeTab, tabs, dispatch, videos, videosMeta, teamId }) => {
  const history = useHistory();
  const handleTabChange = (tabNbr) => {
    let path = "";
    if (tabNbr === 3) {
      path = `/teams/${teamId}/training-documents`;
    } else if (tabNbr === 2) {
      path = `/teams/${teamId}/training-videos`;
    } else if (tabNbr === 1) {
      path = `/teams/${teamId}/training-videos?tab=me`;
    } else if (tabNbr === 0) {
      path = `/teams/${teamId}/training-videos?tab=mo`;
    }

    if (path) {
      history.push(path);
    }

    dispatch({
      type: "setActiveTab",
      value: tabNbr,
    });
  };

  return (
    <div>
      <VideosTabs
        activeTab={activeTab}
        tabs={tabs.map((t, iDx) => ({
          ...t,
          component: () => (
            <ListContainer
              id={`videoContainer-${iDx}-${Date.now()}`}
              activeTab={activeTab}
              dispatch={dispatch}
              videos={videos}
              videosMeta={videosMeta}
            />
          ),
        }))}
        handleChange={handleTabChange}
      />
    </div>
  );
};

export default Mindfulness;
